<template>
  <div class="mobile-menu__profile">
    <a :href="urlLanguagePrefix + '/cabinet'" v-if="auth" class="mobile-menu__profile-card mobile-menu__profile-card--auth">
      <span class="mobile-menu__profile-avatar">
        <img :src="userData.avatar" alt="">
      </span>
      <span class="mobile-menu__profile-info">
        <span class="mobile-menu__profile-title" v-html="$t('mobile.menu.cabinet-logged-text')"></span>
        <!--        <span class="mobile-menu__profile-bonuses">-->
        <!--          <img src="/img/svgo/product-page/bonus_icon.svg" alt="bonus-icon" class="mobile-menu__profile-bonuses-icon">-->
        <!--          <span>{{ totalBonusesInCurrency }}</span>-->
        <!--          <span>{{ $t('mobile.menu.bonuses-title') }}</span>-->
        <!--        </span>-->
      </span>
    </a>
    <div v-else @click="openAuthModal" class="mobile-menu__profile-card mobile-menu__profile-card--no-auth">
      <div class="mobile-menu__profile-no-auth-text" v-html="$t('mobile.menu.cabinet-no-logged-text')"></div>
      <!--      <img src="/img/svgo/product-page/bonus_icon.svg" alt="bonus-icon">-->
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'MobileMenuProfile',
  computed: {
    ...mapGetters(['urlLanguagePrefix', 'isUkLanguage', 'totalBonusesInCurrency']),
    ...mapState({
      auth: state => state.user.auth,
      userData: state => state.user.user_data
    })
  },
  methods: {
    openAuthModal () {
      this.$modal.show('auth-modal')
    }
  }
}
</script>

<style lang="sass">
.mobile-menu__profile
  &-no-auth-text
    font-weight: 400
    font-size: 14px
    line-height: 1.4
    span
      color: #3E77AA
      border-bottom: 1px dashed #3E77AA
      &:hover
        border-bottom-color: transparent
</style>
<style lang="sass" scoped>
.mobile-menu__profile
  margin-bottom: 15px
  &-bonuses
    display: flex
    align-items: center
    font-size: 14px
    &-icon
      width: 18px
      margin-right: 5px
    span
      margin-right: 5px
      display: inline-block
  &-title
    color: #333
    font-size: 14px
    font-weight: 500
    margin-bottom: 5px
    display: inline-block
  &-info
    width: calc(100% - 60px)
  &-avatar
    width: 45px
    margin-right: 15px
    font-size: 0
    border-radius: 50%
    overflow: hidden
    img
      width: 100%
  &-card
    display: flex
    color: #333
    align-items: flex-start
    &--auth
      padding: 10px 15px
      background-color: #F8F8F8
    &--no-auth
      margin: 0 15px
      border: 1px solid #E7E7E7
      border-radius: 3px
      padding: 12px 14px
      align-items: center
      img
        width: 24px
        margin-left: 10px
</style>
